import { resolve } from 'styled-jsx/css';
import iOsAppStore from 'public/static/images/app-store-promo.svg';
import googlePlayBadge from 'public/static/images/google-play-badge.svg';
import { useRouter } from 'next/router';
import tapEvent, { FooterAction } from 'lib/Tracking/Footer/TapEvent';
import useEvents from 'lib/hooks/useEvents';
import { useTranslation } from 'react-i18next';
import { SourcePages } from 'lib/EventSchema';

interface AppBadgesProps {
  onBadgeClick?: (trackingSection: string) => () => void;
}

/* istanbul ignore next */
const css = resolve`
  .ios {
    width: 127px;
  }

  .android {
    width: 143px;
  }

  .app-badges {
    width: 287px;
    display: flex;
    justify-content: space-between;
  }

`;

const APPS = Object.freeze([
  {
    href: 'https://itunes.apple.com/us/app/id1058636900?utm_source=homepage&amp;utm_medium=footer-link&amp;utm_campaign=app%20install%20footer%20link',
    className: 'ios',
    alt: 'App Store',
    src: iOsAppStore,
    trackingSection: 'app_store',
  },

  {
    href: 'https://play.google.com/store/apps/details?id=com.autolist.autolist&referrer=utm_source%3Dhomepage%26utm_medium%3Dfooter-link%26utm_campaign%3Dapp%20install%20footer%20link',
    className: 'android',
    alt: 'Google Play',
    src: googlePlayBadge,
    trackingSection: 'google_play',
  },
]);

export default function AppBadges({ onBadgeClick }: AppBadgesProps): JSX.Element {
  const logger = useEvents();
  const { asPath } = useRouter();
  const { t } = useTranslation();

  const defaultHandleClick = (trackingSection: string) => (): void => {
    logger.log(
      tapEvent({ action: trackingSection as FooterAction, pathName: asPath as SourcePages })
    );
  };

  return (
    <div className={`app-badges ${css.className}`}>
      {APPS.map(({ href, className, alt, src, trackingSection }) => (
        <a
          data-testid="app-badge"
          target="_blank"
          aria-label={t('accessibility.newWindow')}
          rel="nofollow"
          href={href}
          key={className}
          onClick={
            onBadgeClick ? onBadgeClick(trackingSection) : defaultHandleClick(trackingSection)
          }
        >
          <img loading="lazy" className={`${className} ${css.className}`} alt={alt} src={src} />
        </a>
      ))}
      {css.styles}
    </div>
  );
}
